import axios from "axios";

function traerInformeCompensacion(data) {
    return axios.post('api/informe-compensacion/turnosPorClienteMensual', data).then(r => r.data).catch(r => r);
}

function traerInformeCompensacionAsociado(data) {
    return axios.post('api/informe-compensacion/turnosPorAsociadoMensual', data).then(r => r.data).catch(r => r);

}

function traerInformePagos(data) {
    return axios.post('api/informe-pagos/pagoCompensacionAsociado', data).then(r => r.data).catch(r => r);
}


function traerInformeFondos(data) {
    return axios.post('api/informe-fondos/fondoGeneral', data).then(r => r.data).catch(r => r);
}

function traerFecha() {
    return axios.get('api/informe-fondos/traerFecha').then(r => r.data).catch(r => r);
}

function informeFondo(data) {
    return axios.post('api/informe-fondos/informeFondo', data).then(r => r.data).catch(r => r);
}

function traerFechaPago(filtrar) {
    return axios.get('api/informe-pagos/traerFechaPago/' + filtrar + '').then(r => r.data).catch(r => r);
}

function informePagoCompensacion(data) {
    return axios.post('api/informe-pagos/informePagoCompensacion', data).then(r => r.data).catch(r => r);
}

function exportarFondosPendientes() {
    return axios.get('api/informe-fondos/exportarFondosPendientes').then(r => r.data).catch(r => r);
}


export {
    traerInformeCompensacion,
    traerInformePagos,
    traerInformeCompensacionAsociado,
    traerInformeFondos,
    informeFondo,
    traerFecha,
    traerFechaPago,
    informePagoCompensacion,
    exportarFondosPendientes
}
